export default "__VITE_ASSET__CUnq2Gko__"